






































import { defineComponent, onMounted, ref } from '@nuxtjs/composition-api';
import LoginForm from '~/modules/customer/components/molecules/LoginForm.vue';
import ContentBlocks from "~/components/ContentBlocks.vue";
import { SfButton } from "@storefront-ui/vue";
import { useContent } from '~/composables';

import HTMLContent from "~/components/HTMLContent";
import PictimeCarousel from "~/components/organisms/PictimeCarousel.vue";
import PictimeCarouselItem from "~/components/organisms/_internal/PictimeCarouselItem.vue";
import { htmlSplitByClass } from '~/helpers/htmlDecoder';

export default defineComponent({
  layout: 'login',
  name: 'Login',
  components: {
    ContentBlocks,
    LoginForm,
    SfButton,
    HTMLContent,
    PictimeCarousel,
    PictimeCarouselItem
  },
  setup() {
    const { loadBlocks } = useContent();

    const blocks = ref([]);
    const blockHomepagePictoServices = ref('');
    const blockServicesBanner = ref('');
    const blockServicesBannerMobile = ref([]);

    onMounted(async () => {
      blocks.value = await loadBlocks({ identifiers: ['homepage-picto-services', 'homepage-services', 'homepage-services-mobile'] });
      blockHomepagePictoServices.value = blocks.value[0]?.content;
      blockServicesBanner.value = blocks.value[1]?.content;
      blockServicesBannerMobile.value = htmlSplitByClass(blocks.value[2]?.content, '.solutions-banner__card');
    });

    return {
      blockHomepagePictoServices,
      blockServicesBanner,
      blockServicesBannerMobile,
    }
  }
});
